import { render, staticRenderFns } from "./taskDeliverList-02.vue?vue&type=template&id=a648fc06&scoped=true"
import script from "./taskDeliverList-02.vue?vue&type=script&lang=js"
export * from "./taskDeliverList-02.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverList-02.vue?vue&type=style&index=0&id=a648fc06&prod&lang=css"
import style1 from "./taskDeliverList-02.vue?vue&type=style&index=1&id=a648fc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a648fc06",
  null
  
)

export default component.exports